import React, { useState } from 'react';
import { InfoBox, InputGroup } from '../Common';

const fmtCur = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 });

const KellyTool = () => {
    const [cap, setCap] = useState(1000000);
    const [wr, setWr]   = useState(45);
    const [rr, setRr]   = useState(1.5);
    const [sl, setSl]   = useState(10);
    const [ls, setLs]   = useState(65);

    const wr_dec  = wr / 100;
    const q       = 1 - wr_dec;
    const k       = rr === 0 ? 0 : ((rr * wr_dec) - q) / rr;
    const rk      = k / 2;
    const riskAmt = k > 0 ? cap * rk : 0;
    const lpl     = sl * ls;                              // loss per lot
    const lots    = lpl > 0 && k > 0 ? riskAmt / lpl : 0;

    return (
        <div className="tct-tool-container">
            <div className="tct-panel-title">Kelly Position Sizing</div>

            <div className="tct-input-wrap d-flex flex-wrap gap-2">
                <InputGroup label="Capital"        value={cap} onChange={setCap} />
                <InputGroup label="Win Rate %"     value={wr}  onChange={setWr} step="5"   />
                <InputGroup label="Reward:Risk Ratio" value={rr} onChange={setRr} step="0.1" />
                <InputGroup label="Stoploss Pts"   value={sl}  onChange={setSl} />
                <InputGroup label="Lot Size"       value={ls}  onChange={setLs} />
            </div>

            <div className="tct-results-grid mt-4">

                {/* Card 1 — Kelly fractions */}
                <div className="tct-card">
                    <div className="tct-data-row">
                        <span className="tct-label">Full Kelly Fraction</span>
                        <span className="tct-value big-value" style={{ color: 'var(--purple, #8b5cf6)' }}>
                            {(k * 100).toFixed(2)}%
                        </span>
                    </div>
                    <div className="tct-data-row" style={{ borderBottom: 'none' }}>
                        <span className="tct-label">Recommended (Half Kelly)</span>
                        <span className="tct-value big-value val-blue">
                            {(rk * 100).toFixed(2)}%
                        </span>
                    </div>
                </div>

                {/* Card 2 — Derived amounts */}
                <div className="tct-card">
                    <div className="tct-data-row">
                        <span className="tct-label">Amount to Risk (Half Kelly)</span>
                        <span className="tct-value">
                            ₹{fmtCur.format(riskAmt)}
                        </span>
                    </div>
                    <div className="tct-data-row" style={{ borderBottom: 'none' }}>
                        <span className="tct-label">Lots Permitted</span>
                        <span className="tct-value big-value val-blue">
                            ≈ {Math.floor(lots)} lots
                        </span>
                    </div>
                </div>

            </div>

            <InfoBox
                title="Kelly Criterion in Trading: The Optimal Bet Size"
                meta="Learn how the Kelly Criterion helps traders determine optimal position size."
                sections={[
                    {
                        title: 'Introduction',
                        content: 'The Kelly Criterion calculates the optimal percentage of capital to risk per trade.',
                    },
                    {
                        title: 'Example',
                        content: 'Win rate = 45%<br>Reward risk ratio = 1.5<br><br>Kelly result:<br>Optimal risk ≈ 8%<br><br>Most traders use half Kelly to reduce volatility.',
                    },
                ]}
            />
        </div>
    );
};

export default KellyTool;